import React from "react";
import { Form, Input } from "antd";

const FormItemPassword = ({
  label,
  name,
  placeholder,
  rules = [],
  dependencies = [],
  maxLength = 20,
}) => {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
      dependencies={dependencies}
    >
      <Input.Password
        maxLength={maxLength}
        placeholder={placeholder}
      />
    </Form.Item>
  );
};

export default FormItemPassword;
